
import Vue from 'vue';
import { newClient } from './axios-client-new';
import { newClient as newClientOld } from './axios-client-old';
import { get } from '@/util';
import { Dialog } from 'vant';
import { getAppName } from "../util";
let appName = getAppName();
 export const startTime =  'startTheTime'
// 获取当前地区
export const getCountryListAjax = function (language) {
  return newClientOld().post('/web/h5/getCountryList?language=' + language)
}


// 获取当前地区
export const getPayChannelsAjax = function (params) {
  return newClientOld().get('/web/h5/getPayChannels', { params: params })
}
/** 轮询充值结果 / 清除缓存等接口共用的 query：s（来源，默认 h5） */
function getPayLimitQueryParams() {
  return { s: Vue.prototype.$globalData.source ? Vue.prototype.$globalData.source : 'h5' };
}

/**
 * 获取充值限制信息 / 轮询充值结果
 * 接口：GET /api/h5/token/trade/pay/limit/info
 * Query params: s (string) - 必填，与 clearPayLimitCache 一致
 */
export const getPayLimitInfo = function () {
  return newClient().get('/api/h5/token/trade/pay/limit/info', { params: getPayLimitQueryParams() });
}

/**
 * 切换国家等场景清除充值限制相关缓存
 * 接口：GET /api/h5/token/trade/pay/limit/clear
 * Query params: 与 getPayLimitInfo（轮询充值结果）完全一致
 */
export const clearPayLimitCache = function () {
  return newClient().get('/api/h5/token/trade/pay/limit/clear', { params: getPayLimitQueryParams() });
}
/**
 * 点击了卡片中的币商
 * 接口：POST /api/token/trade/pay/limit/click
 * body: { no?: string }
 */
export const clickCardMerchant = function () {
  return newClient().post('/api/h5/token/trade/pay/limit/click', { no: localStorage.getItem('no') });
}
/**
 * 提交用户反馈
 * 接口文档：POST /api/h5/foundation/assistant/syshelp/submitFeedBack
 * payload 示例见接口文档（typeId, reportId, email, platform, device, detail, fileList 等）
 */
export const submitUserFeedback = async function (payload = {}) {
  // 直接以 JSON body 提交，Content-Type 由 axios 客户端处理
  return await newClient().post('/api/h5/token/foundation/assistant/syshelp/submitFeedBack', payload);
}
/**
 * 跳转到反馈页面（来自支付页面）
 * 将在路由中加入 query 参数 from=pay
 * @param {string} orderNo - 订单号
 * @param {string} email - 用户邮箱
 */
export const gotoFeedbackFromPay = function (orderNo, email) {
  const query = { from: 'pay' };
  if (orderNo) {
    query.orderNo = orderNo;
  }
  if (email) {
    query.email = email;
  }
  if (window && window.rootApp && window.rootApp.$router) {
    window.rootApp.$router.push({ path: '/feedback', query });
  } else {
    // 备用：直接改变 location（不推荐）
    const queryStr = new URLSearchParams(query).toString();
    window.location.href = `/#/feedback?${queryStr}`;
  }
}
// 创建订单
export const createOrderAjax = async function (params, payPlatformId, payPage = 0, aggregatePay) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source,
    "payPage": payPage
  }
  // console.log(newJson);
  let api = '';
  if (payPlatformId === 10076) {
    api = process.env.paypal_created_api_10076;
  }
  if (payPlatformId === 10091) {
    api = process.env.paypal_created_api_10091;
  }
  if(aggregatePay === 2) {
    api = process.env.PAYMENTWALL_API
  }

  const payResult = await newClientOld().post(api + '/web/h5/pay/createOrder?param=' + encodeURIComponent(JSON.stringify(newJson)));
  // await  handleFirstPayAfter(payResult);
  console.log('createOrderAjax result:', payResult);
  await handleCreateOrderResult(payResult, payPage);
  return payResult;


}
// pagSmile支付方式

export const pagSmileCreateOrderAjax = async function (params, payPage = 0) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source,
    "payPage": payPage
  }
  // console.log(newJson);
  const payResult = await newClient().post('/api/h5/token/trade/pagSmile/payIn/sendPay?param=' + encodeURIComponent(JSON.stringify(newJson)));
  // await  handleFirstPayAfter(payResult);
  console.log('pagSmileCreateOrderAjax result:', payResult);
  await handleCreateOrderResult(payResult, payPage);
  return payResult;
}

// payssion支付方式
export const payssionCreateOrderAjax = async function (params, payPage = 0) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source,
    "payPage": payPage
  }
  const payResult = await newClient().post('/api/h5/token/trade/payssion/payIn/sendPay', newJson);
  // await  handleFirstPayAfter(payResult);
  console.log('payssionCreateOrderAjax result:', payResult);
  await handleCreateOrderResult(payResult, payPage);
  return payResult;
}

// dlocal 支付方式
export const dlocalCreateOrderAjax = async function (params, payPage = 0) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source,
    "payPage": payPage
  }
  // console.log(newJson);
  const payResult = await newClient().post('/api/h5/token/trade/dlocal/payIn/sendPay?param=' + encodeURIComponent(JSON.stringify(newJson)));
  // await  handleFirstPayAfter(payResult);
  console.log('dlocalCreateOrderAjax result:', payResult);
  await handleCreateOrderResult(payResult, payPage);
  return payResult;

}


// 订单处理后首充
/*
async function handleFirstPayAfter(payResult){

  // 风险值过高
  let message;
  if(get(payResult, 'data.data.payUrl')  == -1 || get(payResult, 'result.payUrl') == -1) {
    message = window.rootApp.$t('m.pay_fail_system_risk')  + window.rootApp.$t('m.support_contant_whatsapp', { msg: appName });
  }

  if(get(payResult, 'data.data.payUrl')  == -2 || get(payResult, 'result.payUrl') == -2) {
    message = window.rootApp.$t('m.paystyle_unavailabel_change_other') + window.rootApp.$t('m.support_contant_whatsapp', { msg: appName });
  }

  if(message){
    Dialog.alert({
      message: message,
      confirmButtonText: 'OK'
    });
    return Promise.reject('error payIndex')
  }
}
*/


// dukPay 支付方式
export const dukPayCreateOrderAjax = async function (params, payPage = 0) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source,
    "payPage": payPage
  }
  // console.log(newJson);
  const payResult = await newClient().post('/api/h5/token/trade/dukPay/payIn/sendPay?param=' + encodeURIComponent(JSON.stringify(newJson)));
  // await  handleFirstPayAfter(payResult);
  console.log('dukPayCreateOrderAjax result:', payResult);
  await handleCreateOrderResult(payResult, payPage);
  return payResult;
}
// CodaPay 支付方式
export const codaPayCreateOrderAjax = async function (params, payPage = 0) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source,
    "payPage": payPage
  }
  // console.log(newJson);
  const payResult = await newClient().post('/api/h5/token/trade/coda/payIn/sendPay?param=' + encodeURIComponent(JSON.stringify(newJson)));
  // await  handleFirstPayAfter(payResult);
  console.log('codaPayCreateOrderAjax result:', payResult);
  await handleCreateOrderResult(payResult, payPage);
  return payResult;
}

// HaiPay 支付方式
export const haiPayCreateOrderAjax = async function (params) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source
  }
  const payResult = await newClient().post('/api/h5/token/trade/haipay/payIn/sendPay', newJson);
  console.log('haiPayCreateOrderAjax result:', payResult);
  await handleCreateOrderResult(payResult, params.payPage);
  return payResult;
}

/**
 * peymentWall-paypal充值方式
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const paymentWallPaypalCreateOrder = async function (params, payPage = 0) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source,
    "payPage": payPage
  }
  // console.log(newJson);
  const payResult = await newClient().post('/api/h5/token/trade/paymentWallPayPal/payIn/sendPay', newJson);
  // await  handleFirstPayAfter(payResult);
  console.log('paymentWallPaypalCreateOrder result:', payResult);
  await handleCreateOrderResult(payResult, payPage);
  return payResult;
}


// 下单对下单结果进行处理
async function handleCreateOrderResult(payResult, payPage = 0) {
  console.log('payResult handleCreateOrderResult', payResult);
   const data = payResult.data.data || payResult.data.result  ;

  if (payResult && data && payResult.data.code === 1) {
    // 显示卡片时，将订单号存储起来。
    localStorage.setItem('no', data.no)
    // 显示卡片（充值拦截）- 先保存 orderData 到 Vuex，延迟设置 fail，让调用方有机会先跳转
    if (data.showCard) {
      // 先保存 orderData 到 Vuex（同步），调用方检测到 fail 后跳转首页时，弹窗组件已能读取到数据
      window.rootApp.$store.dispatch('rechargeIntercept/openExpanded', data);
      try {
        payResult.fail = true;
        if (payResult.data) payResult.data.fail = true;
      } catch (e) {}
      return;
    }

    // 显示弹窗 - 延迟 50ms 再弹，让调用方先完成跳转
    if (data.showDialog) {
      setTimeout(() => {
        Dialog.confirm({
          message: window.rootApp.$t('m.recharge_fail_risk_network'),
          confirmButtonText: window.rootApp.$t('m.feedback'),
          cancelButtonText: window.rootApp.$t('m.falseText')
        }).then(() => {
          gotoFeedbackFromPay(data.no, data.email);
        }).catch(() => {
        });
      }, 50);
      try {
        payResult.fail = true;
        if (payResult.data) payResult.data.fail = true;
      } catch (e) {}
      return;
    }

    // 显示默认提示弹窗 - 延迟 50ms 再弹
    if (data.showDefault) {
      setTimeout(() => {
        Dialog.confirm({
          message: window.rootApp.$t('m.connection_fail_retry_feedback'),
          confirmButtonText: window.rootApp.$t('m.feedback'),
          cancelButtonText: window.rootApp.$t('m.falseText')
        }).then(() => {
          gotoFeedbackFromPay(data.no, data.email);
        }).catch(() => {
        });
      }, 50);
      try {
        payResult.fail = true;
        if (payResult.data) payResult.data.fail = true;
      } catch (e) {}
      return;
    }

    //  需要定时器轮询充值结果
   localStorage.setItem(startTime, data.no )

  }
}









// WEBPACK FOOTER //
// ./src/api/pay.js